import config from 'utils/config';

/* A function that returns the token from the cookie. */
export const storage = {
  getToken: () =>
    document.cookie
      .split('; ')
      .filter((row) => row.startsWith(config.AUTH_TOKEN))
      .map((c) => c.split('=')[1])[0],
};

/**
 * It takes a JWT token, splits it into three parts, takes the second part, replaces the dashes and
 * underscores with pluses and slashes, decodes it, and then parses it into a JSON object
 * @param {string} token - The JWT token that you want to parse.
 * @returns The payload of the JWT token.
 */
export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  if (base64Url) {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
  return null;
}

/**
 * If the token is valid, return the header, otherwise return false
 * @param {string} token - The JWT token to parse
 * @returns the header object.
 */
export function getSession(token: string) {
  if (!token) return false;
  const header = parseJwt(token);
  if (!header) return false;
  const now = Math.floor(Date.now() / 1000);
  if (header.exp <= now) return false;
  return header;
}
